import React from 'react';
import { useMediaQuery, styled } from '@mui/material';
import { Colors } from 'library';
import { Title, Text, Stack } from 'library/ui';
import theme from 'theme';
import { isPast, isToday } from 'date-fns';
import Holiday from './Holiday';
import { formatDateFromDateObject } from 'shared/Dates';
export default function CalendarHeader({
    d,
    start,
    end,
    holidays,
}: {
    d: Date;
    start: Date;
    end: Date;
    holidays: { name: string; date: string }[];
}) {
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const dateDisabled = isPast(d) && !isToday(d);
    return (
        <>
            <HeaderBar
                $dateDisabled={dateDisabled}
                d={d}
                start={start}
                end={end}
                mdDown={mdDown}
                align="center"
                gap="sm"
                justify="center"
            >
                <Title size="h1" tone="inherit">
                    {d.toLocaleDateString('en-US', { day: 'numeric' })}
                </Title>
                <Text size="xs" tone="overlay">
                    {d.toLocaleDateString('en-US', {
                        weekday: 'short',
                        day: 'numeric',
                        month: 'short',
                    })}
                </Text>
            </HeaderBar>
            <Holiday holidays={holidays.filter((day) => day.date === formatDateFromDateObject(d))} />
        </>
    );
}

const HeaderBar = styled(Stack)(
    ({
        $dateDisabled,
        d,
        start,
        end,
        mdDown,
    }: {
        $dateDisabled: boolean;
        d: Date;
        start: Date;
        end: Date;
        mdDown: boolean;
    }) => ({
        height: 75,
        color: Colors.white,
        backgroundColor: $dateDisabled ? Colors.primaryMuted : Colors.primary,
        borderTopRightRadius: d.getDay() === end.getDay() || mdDown ? 18 : 0,
        borderTopLeftRadius: d.getDay() === start.getDay() || mdDown ? 18 : 0,
    }),
);
